//  曝光字段对照表
const MAP_RULE = {
  'k': 'sign',                      // 标识符
  's': 'source_type',               // 来源类型
  'i': 'id',                        // 房源ID+二房东店铺ID+经纪人店铺ID
  'p': 'position'                   // 店铺/房源/banner的坑位
  // 'c1': 'landlord_type',         // 预留字段 c1
  // 'c2': 'tab_name',              // 预留字段 c2
  // 'c3': 'content_type',          // 预留字段 c3
  // 'c4': 'room_type',             // 预留字段 c4   ( shop/room )
};

/**
 * 数据转换
 * @param obj  数据包
 * @param evtType  事件类型
 * @returns {{data: {}}}
 */
function formatDataByRule(obj = {}, evtType = '') {
  let idx = obj.p + 1;
  let exportData = {data: {}};
  exportData['sign'] = obj.k;

  for (let key in obj) {
    if(obj[key] !== '' && obj[key] != 'undefined' && obj[key] !== null){
      if (MAP_RULE[key]) {
        exportData['data'][MAP_RULE[key]] = obj[key];
      } else {
        exportData['data'][key] = obj[key];
      }
    }
  }
  if(exportData['data']['position'] > -1){
    exportData['data']['position'] = idx;
  }
  exportData['data']['action_type'] = evtType;
  delete exportData['data']['sign'];

  return exportData;
}

// 埋点曝光逻辑
const viewLogic = {
  viewDepot: [],
  tempDepot: [],
  interval: 700,
  sendLength: 8,
  viewInterval: null,
  setDepot: function (obj) {
    this.viewDepot.push(obj);
  },
  getDataFromDepot: function () {
    this.tempDepot = [];
    if (this.viewDepot.length <= 0) {
      return false;
    }
    let spliceLen = this.viewDepot.length >= this.sendLength ? this.sendLength : this.viewDepot.length;
    this.tempDepot = this.viewDepot.splice(0, spliceLen);
  },
  sendDataByConfig: function () {
    //  定时发送数据
    this.viewInterval = setInterval(() => {
      this.getDataFromDepot();
      if (this.tempDepot.length > 0) {
        this.tempDepot.forEach((item) => {
          this.sendToGIO(item);
        });
      }
    }, this.interval);
  },
  sendToGIO: function (data) {
    if(data['sign'] === '' || data['sign'] === 'undefined' || data['sign'] === null){
      return false;
    }
    try{
      window.gio('track', data['sign'], data['data'])
    } catch(ex) {
      // do nothing
    }
  }
};

//  埋点指令
export const MGTrack = {
  bind(el, binding) {
    let {value, modifiers} = binding;
    let {click, view} = modifiers;

    if (click || (!view && !click)) {
      let exportData = formatDataByRule(value, 'click');
      el.addEventListener('click', evt => {
        viewLogic.sendToGIO(exportData);  //  send click data
      }, false);
    }
  },
  inserted(el, binding) {
    let {value, modifiers} = binding;
    let {view, click} = modifiers;

    if (view || (!view && !click)) {
      let exportData = formatDataByRule(value, 'view');
      viewLogic.setDepot(exportData);
    }
  }
};

//  曝光数据逻辑处理
viewLogic.sendDataByConfig();




// WEBPACK FOOTER //
// ./src/directives/track.js